import { useFormContext } from "react-hook-form";

import DocumentationIconButton from "components/DocumentationIconButton";
import { ArrowLeft, ArrowRight } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import FullScreenModalFooter from "ds/components/FullScreenModal/Footer";
import Icon from "ds/components/Icon";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";

import { NewScanScheduleContext } from "./context";
import { NewScanScheduleStep } from "./types";

type NewScanScheduleFooterProps = {
  onFinish: () => void;
  isSubmitting?: boolean;
};

const NewScanScheduleFooter = ({ onFinish, isSubmitting }: NewScanScheduleFooterProps) => {
  const { currentStep, currentStepIndex, goToNextStep, goToPreviousStep } =
    useTypedContext(NewScanScheduleContext);
  const { trigger } = useFormContext();

  const isFirstStep = currentStepIndex === 0;
  const isLastStep = currentStep === NewScanScheduleStep.Summary;

  const handleContinue = async () => {
    const isValid = await trigger();

    if (isValid) {
      goToNextStep();
    }
  };

  return (
    <FullScreenModalFooter justify="between">
      <Box gap="medium">
        <DocumentationIconButton
          href={getDocsUrl("/concepts/resources#account-level-resources")}
          tooltipText="Open documentation"
        />
      </Box>
      <Box direction="row" gap="medium">
        {!isFirstStep && (
          <Button
            variant="secondary"
            onPress={goToPreviousStep}
            startIcon={({ className }) => <Icon src={ArrowLeft} className={className} />}
          >
            Back
          </Button>
        )}

        {isLastStep ? (
          <Button variant="primary" onPress={onFinish} loading={isSubmitting}>
            Finish
          </Button>
        ) : (
          <Button
            variant="primary"
            onPress={handleContinue}
            endIcon={({ className }) => <Icon src={ArrowRight} className={className} />}
          >
            Continue
          </Button>
        )}
      </Box>
    </FullScreenModalFooter>
  );
};

export default NewScanScheduleFooter;
